/* eslint-disable quote-props */
// @flow
// TODO Fix lint/flow config.
// Flow does not accept non string literal props but prettier-lint removes the quotes

import { css } from 'styled-components';

export const colors = {
  darkestGray: '#404040',
  defaultGreen: '#57a1bb',
  darkGray2: '464545',
  logoBlue: '#56A1BB',
  saveGreen: '#3B7D1C',
  lightGreen: '#9DE7DC',
  darkGreen: '#8FBC8F',
  error: '#FF6732',
  warn: '#FFC107',
  gray: '#a6adbc',
  grayText: '#757575',
  grey2: 'rgba(87, 87, 87, 0.87)',
  lightGray2: '#5a5a5b;',
  lightGray3: '#f2fafb;',
  backgroundGray: '#EFF1F4',
  black: '#000000',
  red: '#BF1E3B',
  loginRed: '#DE4561',
  white: '#FFFFFF',
  brokenWhite: 'rgba(255, 255, 255, 0.8)',
  translucentWhite: 'rgba(255, 255, 255, 0.2)',
  translucentWhite50: 'rgba(255, 255, 255, 0.5)',
  translucentWhite80: 'rgba(255, 255, 255, 0.8)',
  translucentWhite90: 'rgba(255, 255, 255, 0.9)',
  translucentRed10: 'rgba(222, 69, 97, 0.1)',
  transluscentBlack: 'rgba(0, 0, 0, 0.2)',
  darkGrayBlue: '#26324C',
  darkBlue: '#242a38',
  darkBlue2: '#173847',
  darkNaviBlue: '#18627B',
  newThemeDarkBlue: '#075175',
  translucentDarkBlue: 'rgba(36, 42, 56, 0.5)',
  aquaMarine: '#57a1bb',
  translucentAquaMarine: 'rgba(94, 193, 178, 0.5)',
  transluscentDark: 'rgba(33, 40, 54, 0.2)',
  turquoise: '#64d0d5',
  blueNavi: '#5FA6BF',
  lightCyan: '#67e0bf',
  seafoamBlue: '#50d1ad',
  seafoamBlue2: '#57b5c6',
  seafoamBlue4: '#54d8c4',
  seafoamBlue5: '#47CECD',
  lightBlue: '#57a0c6',
  seagulBlue: '#7AB9D1',
  greyBlue: '#64afd5', // patient dashboard headings
  greyBlue10: '#EFF7FA',
  formSeparator: 'rgba(36, 42, 56, 0.1)',
  warmGray: '#7b7b7b',
  separator: 'rgba(33, 40, 54, 0.09)',
  mediumGray: '#727b8e',
  mediumGray2: '#7d7d7d',
  navyGray: '#465066',
  softBlueTwo: '#5cb3e8',
  softMakrTwo: '#2fd6fd',
  lightGray: '#F5F5F5',
  fadedBlue: '#7883ba',
  fadedMakr: '#1c8bb3',
  perryWinkle: '#7a9bdf',
  whitishGreen: '#11A493',
  blueyGray: '#9aa2b4',
  gold: '#f3c85a',
  silver: '#cccccc',
  darkBlue3: ' #1C6699',
  mediumPurpleBlue: '#2157874D',
  lightPurpleBlue: '#96BBD880',
  grey1: 'rgba(0, 0, 0, 0.66)',
  VeryLightBlue: '#EDF8FF',
  darkBlue4: '#00315C',
  blackShade: '#202020',
  darkPurpleBlue: '#2157874D',
  whitishBlue: '#E8F6FD',
  whitishGreenBlue: '#A5E1FF',
  lightSkyBlue: '#64CCC5',
  greyishLightBlue: '#F3F8F8',
  mediumThemeBlue: '#2485A6',
  aquaGreen: '#51DE79',
  darkTeal: '#004F4F',
  harp: '#E5F5EA',
  teal: '#00514E'
};

const theme = {
  colors,
  borders: {
    dotted: `
      border-color: #a6adbc;
      border-style: dashed;
      border-radius: 5px;
      border-width: 1px;
    `,
    dashed: `
      border-color: #c4c9d2;
      border-style: dashed;
      border-radius: 8px;
      border-width: 1px;
    `
  },
  fontWeight: {
    semiBold: 'font-weight: 500;',
    bold: 'font-weight: 600;',
    bolder: 'font-weight: 700;'
  },
  shadows: {
    default: `
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    `,
    medium: `
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    `,
    mediumStrong: `
      box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.25);
    `,
    large: `
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);
    `
  },
  borderRadius: {
    small: 'border-radius: 4px;',
    medium: 'border-radius: 6px;',
    mediumLarge: 'border-radius: 8px;',
    default: 'border-radius: 10px;',
    large: 'border-radius: 16px;'
  },
  breakpoints: {
    mobile: 0,
    tablet: 737,
    desktop: 1025,
    largeDesktop: 1630
  },
  typography: {
    Raleway: 'font-family: Raleway, sans-serif;',
    OpenSans: "font-family: 'Open Sans', OpenSans, Raleway;"
  },
  spacing: {
    '-6': '-8rem', //       -128px
    '-5.5': '-6rem', //     -96px
    '-5': '-4rem', //       -64px
    '-4.5': '-3rem', //     -48px
    '-4': '-2rem', //       -32px
    '-3.5': '-1.5rem', //   -24px
    '-3': '-1rem', //       -16px
    '-2.5': '-0.75rem', //  -12px
    '-2': '-0.5rem', //     -8px
    '-1': '-0.25rem', //    -4px
    '0': '0', //            0
    '1': '0.25rem', //      4px
    '2': '0.5rem', //       8px
    '2.5': '0.75rem', //    12px
    '3': '1rem', //         16px
    '3.5': '1.5rem', //     24px
    '4': '2rem', //         32px
    '4.5': '3rem', //       48px
    '5': '4rem', //         64px
    '5.5': '6rem', //       96px
    '6': '8rem' //          128px
  },
  gradients: {
    linearBlueTurquoiseLTR: `background-image: linear-gradient(237deg, ${colors.turquoise}, ${colors.blueNavi});`,
    linearTurquoiseBlueTTB: `background-image: linear-gradient(199deg, ${colors.turquoise}, ${colors.blueNavi});`,
    linearFadedBlueSoftBlueLTR: `background-image: linear-gradient(238deg, ${colors.softBlueTwo}, ${colors.fadedBlue});`,
    linearSeafoamBlueSeafoamBlue2LTR: `background-image: linear-gradient(238deg, ${colors.seafoamBlue}, ${colors.seafoamBlue2});`,
    linearLightCyanLightBlueTTB: `background-image: linear-gradient(223deg, ${colors.lightCyan}, ${colors.lightBlue});`,
    linearLightBlueLightCyanTTB: `background-image: linear-gradient(0deg, ${colors.lightCyan}, ${colors.lightBlue});`,
    linearLightBlueLightCyanLTR: `background-image: linear-gradient(270deg, ${colors.lightCyan}, ${colors.lightBlue});`,
    linearSoftBlueTwoFadedBlueLTR: `background-image: linear-gradient(261deg, ${colors.softBlueTwo}, ${colors.fadedBlue});`,
    linearSoftMakrBlueTwoFadedBlueLTR: `background-image: linear-gradient(261deg, ${colors.softMakrTwo}, ${colors.fadedMakr});`,
    BannerGradientCostPage:
      'linear-gradient(118.6deg, #63AECF 0%, #629ECE 30.63%, #458FD3 63.31%, #3A78B1 98.02%);',

    BannerGradientLowerCostPage:
      'linear-gradient(340deg, #8CCEE6 1.25%, #48A5C6 43.02%, #3285A1 100%)',
    CostPageLinear:
      'linear-gradient(118.6deg, rgba(99, 174, 207, 0.8) 0%, rgba(98, 158, 206, 0.8) 30.63%, rgba(69, 143, 211, 0.8) 63.31%, rgba(58, 120, 177, 0.8) 98.02%)',
    LightBlueGradient: 'linear-gradient(180deg, #DBF6FF 0%, #C7F1FF 100%);',
    SecondOpinionHeroTealGradient: 'linear-gradient(180deg, #5BA0A0 0%, #448989 24.66%, #276363 47.93%, #144D4D 72.53%, #0E3434 100%);',
    CurefyVideoBorderGradient: 'linear-gradient(180deg, #D4F3DE -9.16%, #A7EFBF 21.08%, #91D2A7 111.19%)'
  },
  ripple: css`
    position: relative;
    overflow: hidden;
    transform: translate3d(0, 0, 0);

    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      pointer-events: none;
      background-image: radial-gradient(circle, #fff 10%, transparent 10.01%);
      background-repeat: no-repeat;
      background-position: 50%;
      transform: scale(10, 10);
      opacity: 0;
      transition: transform 0.5s, opacity 1s;
    }

    &:active:after {
      transform: scale(0, 0);
      opacity: 0.7;
      transition: 0s;
    }
  `
};

export default theme;
